import {
  ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output,
  ViewEncapsulation
} from '@angular/core';

import { v4 as uuid } from 'uuid';

import { IconSizeEnum, IWarranty, SdFormCheckboxComponent, SdIconComponent } from '@seb/web-design-system/core';

@Component({
  selector: 'sd-warranty-checkbox',
  templateUrl: './warranty-checkbox.component.html',
  styleUrls: ['./warranty-checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdFormCheckboxComponent, SdIconComponent]
})
export class SdWarrantyCheckboxComponent implements OnInit {
  iconSizeEnum = IconSizeEnum;

  @Input()
  showAll = false;

  @Input()
  warranty: IWarranty;

  @Output()
  warrantyClicked = new EventEmitter<void>();

  @HostListener('click', ['$event'])
  onClick(): void {
    this.warranty.state = !this.warranty.state;
    this.warrantyClicked.emit();
  }

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, this.warranty.state ? 'is-checked' : '']
      .filter(Boolean)
      .join(' ');
  }

  ngOnInit() {
    this.warranty.uuid = 'warranty-checkbox-' + uuid();
  }
}
